// ============================================================
// TaglineBanner.js - Teal gradient text banner
// ============================================================

import React from "react";

function TaglineBanner() {
  return (
    <div className="tagline-banner">
      Local Knowledge + Professional Execution + Safety-First Approach
    </div>
  );
}

export default TaglineBanner;
